import { useCallback } from 'react'
import ApiService from 'services/ApiService'

const InteractorTransactionReturLinesSearch = () => {
  const transactionReturLinesSearch = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/transaction/retur-lines/search', payload, (response) => {
      loading(false)
      if (response.code === 7200) {
        callback(response.data)
      } else {
        callback(null)
      }
    })
  }, [])

  return { transactionReturLinesSearch }
}

export default InteractorTransactionReturLinesSearch
